<template>
  <div @keyup.enter="login">
  <el-form :model="form" :rules="rules2" ref="form" label-position="left" label-width="0px" class="demo-ruleForm login-container">
    <h3 class="title">信源微信商城</h3>
    <el-form-item prop="account">
      <el-input type="text" v-model="form.account" auto-complete="off" placeholder="账号"></el-input>
    </el-form-item>
    <el-form-item prop="checkPass">
      <el-input type="password" v-model="form.password" auto-complete="off" placeholder="密码"></el-input>
    </el-form-item>
    <!--<el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>-->
    <el-form-item style="width:100%;">
      <el-button type="primary" style="width:100%;" @click.native.prevent="login" :loading="logining">登录</el-button>
      <!--<el-button @click.native.prevent="handleReset2">重置</el-button>-->
    </el-form-item>
  </el-form>
  <div class="bottom_layer"  style="visibility: visible; width: 100%;">
    <div class="s-bottom-layer-content">
      <p class="lh" >
      <!-- https://beian.miit.gov.cn/#/Integrated/index -->
        <!-- <span class="text-color"></span> -->
        <div style="cursor: pointer;" @click="gov" target="_blank">浙ICP备17053326号-1</div>
      </p>
    </div>
  </div>
  </div>
</template>

<script>
  import * as getData from '../service/getData.js'
  //import NProgress from 'nprogress'
  export default {
    data() {
      return {
        logining: false,
        form: {
          account: '',
          password: ''
        },
        rules2: {
          account: [
            { required: true, message: '请输入账号', trigger: 'blur' },
            //{ validator: validaePass }
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            //{ validator: validaePass2 }
          ]
        },
        checked: true
      };
    },
    mounted(){

    },
    methods: {
      handleReset2() {
        this.$refs.ruleForm2.resetFields();
      },
      gov(){
        window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank');
        // 
      },
      login(ev) {
        var _this = this;
        this.$refs.form.validate((valid) => {
          if (valid) {
            //_this.$router.replace('/table');
            this.logining = true;
            //NProgress.start();
            getData.login(this.form.account,this.form.password).then(res => {
              console.log(res);
              if(res.data.rCode == 'success'){
                sessionStorage.clear()
                sessionStorage['username']=res.data.admin.adminName
                sessionStorage['userId']=res.data.admin.adminId
                sessionStorage['storeid']=res.data.admin.adminStoreId
                sessionStorage['storeName']=res.data.storeName
                sessionStorage['permissions'] = JSON.stringify(res.data.permissions)
                sessionStorage['user']=JSON.stringify(res.data.admin)
                sessionStorage['detailrolds']=JSON.stringify(res.data.detailrolds)

                getData.myAdminPermissions().then(res =>{
                  if(res.data.rCode=='success'){
                    sessionStorage['myPermission']=JSON.stringify(res.data.myPermission)
                    console.log(this.$checkPermissions('storeIndex'))
                    if(this.$checkPermissions('storeIndex')){
                      this.$router.push({ path: '/indexForStore' });
                    }else{
                      this.$router.push({ path: '/index' });
                    }

                  }else{
                    this.$message({
                      message: "session获取失败",
                      type: 'error'
                    });
                  }

                })
                //sessionStorage['navbarIndex']=0
                //this.$store.state.username=res.data.adminName

              }else{
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                });
                this.logining = false;
              }
            })
          } else {
            this.logining = false;
            console.log('error submit!!');
            return false;
          }
        });
      }
    }
  }

</script>

<style lang="scss" scoped>
  .login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 180px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }
    .remember {
      margin: 0px 0px 35px 0px;
    }
  }
.bottom_layer {
    visibility: hidden;
    width: 3000px;
    position: fixed;
    z-index: 302;
    bottom: 0;
    left: 0;
    height: 39px;
    padding-top: 1px;
    zoom: 1;
    margin: 0;
    line-height: 39px;
    background: #fff;
}
.s-bottom-layer-content {
    margin: 0 17px;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/view/login.vue